import React from 'react'

const KR = () => {
    return (
        <div>

        </div>
    )
}

export default KR
